// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInCalendarWeeks as fn } from "../differenceInCalendarWeeks.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInCalendarWeeks = convertToFP(fn, 2);

// Fallback for modularized imports:
export default differenceInCalendarWeeks;
